import React, { useEffect, useState, useRef } from 'react';
import { Box, Paper, Typography, Button, Slider, TextField } from '@mui/material';

/* [D-506] 🎧 Музика «Студії» (v-5) — окрема від музики редактора v-3 і Хаба.
   OWNER 09.10: «надати мені саме для застосунку v-5 окремо завантаження та редагування музики яка буде грати тільки під час заставки
   очікування на v-5. Приклади як у нас організована музика є наприклад у моєму проекті @ZODI_AQ_BOT» → як у ZODIAQ: кілька треків,
   назва (її бачить учень), увімкнено/ні, гучність. У Студії на вході — випадковий трек, учень може вибрати інший чи вимкнути звук. */
export default function StudioMusicPage() {
  const [tracks, setTracks] = useState([]);
  const [volume, setVolume] = useState(40);
  const [uploading, setUploading] = useState(false);
  const [msg, setMsg] = useState(null);
  const [names, setNames] = useState({});
  const inputRef = useRef(null);
  const tok = localStorage.getItem('dashboard_token');
  const H = { Authorization: 'Bearer ' + tok };

  const load = () => fetch('/api/studio-music', { headers: H })
    .then(r => r.json()).then(d => { setTracks((d && d.tracks) || []); if (d && d.volume != null) setVolume(d.volume); }).catch(() => {});
  useEffect(() => { load(); }, []);   // eslint без react-hooks — як у сусідніх сторінках

  const say = (type, text) => setMsg({ type, text });
  const upload = async (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    setUploading(true); setMsg(null);
    try {
      const fd = new FormData(); fd.append('file', file);
      const r = await fetch('/api/studio-music/upload', { method: 'POST', headers: H, body: fd });
      let j = null; try { j = await r.json(); } catch (e2) {}
      if (r.ok) { say('ok', '✅ Трек додано'); load(); }
      else say('err', '❌ ' + ((j && (j.detail || j.message)) || ('Помилка ' + r.status)));
    } catch (e3) { say('err', '❌ ' + (e3.message || 'Не вдалося завантажити')); }
    setUploading(false);
    if (inputRef.current) inputRef.current.value = '';
  };
  const rename = async (id) => {
    const nm = (names[id] || '').trim(); if (!nm) return;
    const r = await fetch('/api/studio-music/' + id + '/name', { method: 'POST', headers: { ...H, 'Content-Type': 'application/json' }, body: JSON.stringify({ name: nm }) });
    if (r.ok) { setNames(n => { const c = { ...n }; delete c[id]; return c; }); say('ok', '✅ Назву збережено'); load(); } else say('err', '❌ Не вдалося зберегти назву');
  };
  const toggle = async (id) => { await fetch('/api/studio-music/' + id + '/toggle', { method: 'POST', headers: H }); load(); };
  const del = async (id) => {
    if (!window.confirm('Видалити трек?')) return;
    await fetch('/api/studio-music/' + id, { method: 'DELETE', headers: H }); load();
  };
  const saveVolume = async (v) => {
    const r = await fetch('/api/studio-music/volume', { method: 'POST', headers: { ...H, 'Content-Type': 'application/json' }, body: JSON.stringify({ volume: v }) });
    if (r.ok) say('ok', '✅ Гучність ' + v + ' %'); else say('err', '❌ Не вдалося зберегти гучність');
  };
  const on = tracks.filter(t => t.enabled).length;

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" sx={{ color: '#FFD700', mb: 1 }}>🎧 Музика Студії (v-5)</Typography>
      <Typography sx={{ color: '#888', fontSize: 13, mb: 2 }}>
        Грає лише на заставці «Обробляю ваше відео» у Студії (v-5). Окрема від музики редактора v-3 і Хаба.
        На вході — випадковий трек з увімкнених; учень бачить назву, може вибрати інший або вимкнути звук.
      </Typography>

      <Paper sx={{ p: 2, mb: 2, bgcolor: '#1a1a2e', border: '1px solid rgba(255,215,0,.28)' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
          <Button size="small" variant="outlined" disabled={uploading} onClick={() => inputRef.current && inputRef.current.click()}
                  sx={{ color: '#FFD700', borderColor: '#FFD700', fontSize: 12 }}>{uploading ? '⏳ Завантаження…' : '⬆ Додати трек'}</Button>
          <input ref={inputRef} type="file" accept="audio/*,.mp3,.ogg,.m4a,.aac,.wav" style={{ display: 'none' }} onChange={upload} />
          <Typography sx={{ color: '#667', fontSize: 11 }}>mp3 / ogg / m4a / aac / wav · макс 12 МБ · увімкнено {on} з {tracks.length}</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, ml: 'auto', minWidth: 260 }}>
            <Typography sx={{ color: '#FFD700', fontSize: 13, whiteSpace: 'nowrap' }}>🔊 Гучність {volume} %</Typography>
            <Slider size="small" value={volume} min={0} max={100} step={5} onChange={(e, v) => setVolume(v)} onChangeCommitted={(e, v) => saveVolume(v)}
                    sx={{ color: '#FFD700' }} />
          </Box>
        </Box>
        {msg && <Typography sx={{ color: msg.type === 'ok' ? '#34d399' : '#f87171', fontSize: 13, mt: 1 }}>{msg.text}</Typography>}
      </Paper>

      {tracks.length === 0 && <Typography sx={{ color: '#777', fontSize: 13 }}>Ще немає треків. Додайте кілька — у Студії вмикатимуться випадково.</Typography>}
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: 1.5 }}>
        {tracks.map(t => (
          <Paper key={t.id} sx={{ p: 1.5, bgcolor: '#1a1a2e', border: '1px solid ' + (t.enabled ? 'rgba(52,211,153,.45)' : '#33334a'), opacity: t.enabled ? 1 : 0.65 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
              <span style={{ fontSize: 18 }}>{t.enabled ? '🎶' : '🔇'}</span>
              <TextField size="small" variant="standard" fullWidth value={names[t.id] != null ? names[t.id] : (t.name || '')}
                         onChange={e => setNames(n => ({ ...n, [t.id]: e.target.value }))} onKeyDown={e => { if (e.key === 'Enter') rename(t.id); }}
                         inputProps={{ maxLength: 120, style: { color: '#fff', fontSize: 14 } }} />
              {names[t.id] != null && names[t.id] !== t.name && <Button size="small" onClick={() => rename(t.id)} sx={{ color: '#FFD700', minWidth: 0, fontSize: 12 }}>💾</Button>}
            </Box>
            <audio src={t.url} controls preload="none" style={{ width: '100%', height: 32 }} onPlay={e => { e.target.volume = volume / 100; }} />
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
              <Typography sx={{ color: '#667', fontSize: 11, flex: 1 }}>{t.size ? (t.size / 1048576).toFixed(1) + ' МБ' : ''}{t.created_at ? ' · ' + t.created_at : ''}</Typography>
              <Button size="small" onClick={() => toggle(t.id)} sx={{ color: t.enabled ? '#34d399' : '#888', fontSize: 11, minWidth: 0 }}>{t.enabled ? 'увімкнено' : 'вимкнено'}</Button>
              <Button size="small" onClick={() => del(t.id)} sx={{ color: '#f87171', fontSize: 11, minWidth: 0 }}>🗑</Button>
            </Box>
          </Paper>
        ))}
      </Box>
    </Box>
  );
}
